<div class="input-group flex-nowrap">
  <span class="input-group-text" ><i class="bi bi-calendar"></i>
  </span>
  <input [readOnly]="true" [minDate]="{year: minDate.year, month: minDate.month, day: minDate.day }"
    [maxDate]="{year: maxDate.year, month: maxDate.month, day: maxDate.day }" class="form-control"
    placeholder="yyyy-mm-dd" name="dp" [value]="getFormattedString(localValue)" (dateSelect)="valueChanged($event)"
    ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()" />
  <a (click)="d.toggle()" class="input-group-text bg-light" ><i class="bi bi-calendar3 fw-bold"></i></a>
</div>
